(function () {
  'use strict';

  function initRow(section) {
    var scroll  = section.querySelector('.cs-products-row__scroll');
    var prev    = section.querySelector('.cs-products-row__arrow--prev');
    var next    = section.querySelector('.cs-products-row__arrow--next');
    if (!scroll) return;

    /* ── Scroll amount = one card width + gap ── */
    function getStep() {
      var item = scroll.querySelector('.cs-products-row__item');
      if (!item) return 280;
      var gap = parseInt(getComputedStyle(scroll.querySelector('.cs-products-row__track')).columnGap || '24', 10);
      return item.offsetWidth + gap;
    }

    /* ── Arrow click handlers ── */
    if (prev) {
      prev.addEventListener('click', function () {
        scroll.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        scroll.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }

    /* ── Update arrow disabled state ── */
    function refreshArrows() {
      if (!prev && !next) return;
      var atStart = scroll.scrollLeft <= 2;
      var atEnd   = scroll.scrollLeft + scroll.offsetWidth >= scroll.scrollWidth - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    scroll.addEventListener('scroll', refreshArrows, { passive: true });
    refreshArrows();

    /* Recheck on resize (card widths change) */
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(refreshArrows).observe(scroll);
    }
  }

  /* ── Init all rows on page ── */
  function initAll() {
    document.querySelectorAll('.cs-products-row').forEach(initRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ── Re-init after Shopify theme editor section updates ── */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.cs-products-row');
    if (section) initRow(section);
  });

})();
